export default __webpack_public_path__ + "static/media/ammonia.4fc69667.jpg";